import PropTypes from 'prop-types';
import type { FC, ReactNode } from 'react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSettings from 'src/hooks/useSettings';
import { useSelector } from 'src/store';
import { Pos } from 'src/types/pos';
import { SocketDataInterface } from 'src/types/socket';
import { StationType } from 'src/types/station';
import { useLocation } from 'react-router-dom';

interface PosGuardProps {
  children?: ReactNode;
}

const PosGuard: FC<PosGuardProps> = ({ children }) => {
  const { pathname } = useLocation();
  const { socketData, isConnected }: SocketDataInterface = useSelector((state) => state.socket);
  const posApiKey = socketData?.posApiKey;
  const posDeviceIdentifier = socketData?.posDeviceIdentifier;
  const { settings } = useSettings();
  const pos = settings?.pos;
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isConnected && socketData?.stationType === StationType.Sale) {
      if (pos === Pos.Square) {
        if (!posApiKey && pathname !== '/square/auth') {
          navigate('/square/auth');
        } else if (posApiKey && !posDeviceIdentifier && pathname !== '/square/locations') {
          navigate('/square/locations');
        } else if (posApiKey && posDeviceIdentifier && !pathname.match(/(\/app\/(.*))/g)) {
          navigate('/app/attract');
        }
      } else if (pos === Pos.Ronin) {
        if (!posApiKey || !posDeviceIdentifier) {
          navigate('/pos/pair');
        }
      }
    }
  }, [isConnected, socketData, posApiKey, posDeviceIdentifier, pos, pathname, navigate]);

  return (
    <>
      {children}
    </>
  );
};

PosGuard.propTypes = {
  children: PropTypes.node
};

export default PosGuard;
